import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "semantic-ui-react";
import { cn } from "@iscr/lib/utils";
const STATUS_ICONS = {
    pass: { name: "check circle", color: "green" },
    fail: { name: "times circle", color: "red" },
    warning: { name: "exclamation circle", color: "yellow" },
    info: { name: "info circle", color: "grey" },
    neutral: { name: "minus circle", color: "grey" },
};
/** Maps a yes/no check to a status, e.g. `checkStatus(isVerified)` or `checkStatus(isMigrated, "neutral")` */
export const checkStatus = (passed, failStatus = "fail") => passed ? "pass" : failStatus;
/**
 * A list of checks, each with a status icon, a label and an optional value - for showing the result of a
 * lookup or verification, e.g. eligibility or onboarding status.
 */
export function StatusChecklist({ items, className }) {
    return (_jsx("ul", { className: cn("m-0 p-0 list-none divide-y divide-gray-200", className), children: items.map(({ key, label, description, value, status = "neutral", icon }) => (_jsxs("li", { className: "flex items-start gap-2 py-2", children: [_jsx(Icon, { name: icon !== null && icon !== void 0 ? icon : STATUS_ICONS[status].name, color: STATUS_ICONS[status].color }), _jsxs("div", { className: "flex-1", children: [_jsx("div", { children: label }), description && _jsx("div", { className: "text-xs text-gray-500", children: description })] }), value !== undefined && _jsx("div", { className: "text-right text-gray-600", children: value })] }, key))) }));
}
